// src/pages/calculator/ui.jsx — kleine gedeelde UI-bouwstenen (Tailwind)
import React from 'react';
import { pct } from '../../lib/calculatorEngine';

export const scrollNaarBoven = () => {
  try {
    const el = document.getElementById('rekenhulp');
    if (el) {
      const top = el?.getBoundingClientRect()?.top + window.scrollY - 70;
      window.scrollTo({ top: Math.max(0, top) });
    } else {
      window.scrollTo({ top: 0 });
    }
  } catch (e) {}
};

export const track = (event, data = {}) => { try { window.dataLayer = window.dataLayer || []; window.dataLayer?.push({ event, ...data }); } catch (e) {} };

export const Eyebrow = ({ children, className = '' }) => <div className={`text-xs font-semibold uppercase tracking-wider text-stone-500 ${className}`}>{children}</div>;
export const Card = ({ children, className = '', deep = false }) => (
  <div className={`rounded-2xl border p-5 ${deep ? 'bg-emerald-950 text-emerald-50 border-emerald-950' : 'bg-white border-stone-200'} ${className}`}>{children}</div>
);
export const Note = ({ children, warn = false, className = '' }) => <p className={`text-sm ${warn ? 'text-orange-800' : 'text-stone-500'} ${className}`}>{children}</p>;
export const Tag = ({ children, tone = 'sun' }) => {
  const t = { sun: 'bg-amber-50 text-amber-700', partner: 'bg-emerald-50 text-emerald-800', grey: 'bg-stone-100 text-stone-500' }?.[tone];
  return <span className={`ml-1.5 inline-block rounded-full px-2 py-0.5 text-[11px] font-semibold align-middle whitespace-nowrap ${t}`}>{children}</span>;
};
export const Btn = ({ children, onClick, type = 'button', ghost = false, sm = false, pressed, className = '' }) => (
  <button type={type} onClick={onClick} aria-pressed={pressed}
    className={`rounded-xl font-semibold text-center transition ${sm ? 'px-3.5 py-2 text-sm' : 'px-5 py-3.5'} ${ghost ? 'border border-stone-300 bg-transparent text-stone-900' : 'bg-emerald-700 text-white hover:bg-emerald-800'} ${pressed ? '!bg-emerald-50 !text-emerald-800 !border !border-emerald-700' : ''} ${className}`}>
    {children}
  </button>
);
export const Bar = ({ label, value, sun = false }) => (
  <div className="grid grid-cols-[minmax(120px,160px)_minmax(0,1fr)_54px] items-center gap-2.5 text-sm">
    <span>{label}</span>
    <div className="h-3 overflow-hidden rounded-full bg-stone-200"><i className={`block h-full rounded-full transition-all ${sun ? 'bg-amber-500' : 'bg-emerald-700'}`} style={{ width: `${Math.round(Math.min(1, Math.max(0, value)) * 100)}%` }} /></div>
    <span className="text-right font-mono tabular-nums">{pct(value)}</span>
  </div>
);
